import { boot } from 'quasar/wrappers'
import * as Sentry from '@sentry/browser'

export default boot(({ app }) => {
  const options = {
    dsn: 'https://eb9031586c16c085edb9d466a2111e2d@o4507338385522688.ingest.de.sentry.io/4507338572890192',
    release: process.env.SENTRY_RELEASE,
    integrations: [],
    ignoreErrors: [],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api-dev.apppair\.com\/api/,
      /^https:\/\/api-main.apppair\.com\/api/,
      /^https:\/\/gateway.techsuite.\.ai\/api/,
      /^https:\/\/api-master.techsuite.\.ai\/api/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  }

  // Wraps native APIs to capture breadcrumbs. (default)
  Sentry.addIntegration(Sentry.breadcrumbsIntegration())
  // Collect & view performance insights for JavaScript programs with Sentry’s JavaScript Profiling integration.
  Sentry.addIntegration(Sentry.browserProfilingIntegration())
  // Capture performance data for the Browser.
  Sentry.addIntegration(Sentry.browserTracingIntegration())
  // Captures all Console API calls via `captureException` or `captureMessage`.
  Sentry.addIntegration(Sentry.captureConsoleIntegration({ levels: ['debug', 'error'] }))
  // Adds source code from inline JavaScript of the current page's HTML.
  Sentry.addIntegration(Sentry.contextLinesIntegration())
  // Allows you to inspect the contents of a processed event and hint object that gets passed to beforeSend or beforeSendTransaction.
  Sentry.addIntegration(Sentry.debugIntegration())
  // Deduplicate certain events to avoid receiving duplicate errors. (default)
  Sentry.addIntegration(Sentry.dedupeIntegration())
  // Extracts all non-native attributes from the error object and attaches them to the event as extra data.
  Sentry.addIntegration(Sentry.extraErrorDataIntegration())
  // Allows the SDK to provide original functions and method names, even when those functions or methods are wrapped by our error or breadcrumb handlers. (default)
  Sentry.addIntegration(Sentry.functionToStringIntegration())
  // Attaches global handlers to capture uncaught exceptions and unhandled rejections. (default)
  Sentry.addIntegration(Sentry.globalHandlersIntegration())
  // Captures errors on failed requests from Fetch and XHR and attaches request and response information.
  Sentry.addIntegration(Sentry.httpClientIntegration())
  // Attaches HTTP request information, such as URL, user-agent, referrer, and other headers to the event. (default)
  Sentry.addIntegration(Sentry.httpContextIntegration())
  // Adds module metadata to stack frames.
  Sentry.addIntegration(Sentry.moduleMetadataIntegration())
  // Capture a video-like reproduction of what was happening in the user's browser.
  Sentry.addIntegration(Sentry.replayIntegration())
  // Allows you to apply a transformation to each frame of the stack trace.
  Sentry.addIntegration(Sentry.reportingObserverIntegration())
  // Allows you to apply a transformation to each frame of the stack trace.
  Sentry.addIntegration(Sentry.rewriteFramesIntegration())
  // Adds session timing data to events.
  Sentry.addIntegration(Sentry.sessionTimingIntegration())
  // Wraps native time and events APIs (`setTimeout`, `setInterval`, `requestAnimationFrame`, `addEventListener/removeEventListener`) in `try/catch` blocks to handle async exceptions. (default)
  Sentry.addIntegration(Sentry.browserApiErrorsIntegration())

  Sentry.init(options)

  app.config.globalProperties.$q.sentry = Sentry
})

// try {
//   const reviews = await fetchMovieReviews(movie)
//   renderMovieReviews(reviews)
// } catch (e) {
//   const fetchError = new Error(`Failed to fetch reviews for: ${movie}`)
//   fetchError.cause = e
//   Sentry.captureException(fetchError)
//   renderMovieReviewsError(fetchError)
// }
